import { lazy } from 'react';

const FilmPageAsync = lazy(() => import('./FilmPage'));

export default FilmPageAsync;
